import { trackEvent } from "services/frontend/Segment";

export const useRecordSearchResultSelected = () => {
  const recordSearchResultSelected = (args: {
    query: string;
    article_clicked: boolean;
    article_title: string;
    article_id: string;
  }) => {
    trackEvent("Search Result Selected", args);
  };

  return recordSearchResultSelected;
};
